import React, { useState, useEffect, useMemo } from "react";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import { InputGroup, Button, FormControl, Col, Spinner, Accordion, Card, Row } from "react-bootstrap";
import _ from "lodash";
import ApiAgentCommission from "../../../core/api/api.agentCommission";
import { FormProvider, useForm, Controller } from "react-hook-form";
import DataGrid from "./DataGrid";
import { useLocation, useNavigate } from "react-router-dom";
import { CreateCommissionGroupModal } from "./CreateCommissionGroupModal";
import AddCircle from "@mui/icons-material/AddCircleRounded";
import { tools } from "../../../core/utils/tools";
import GlobalFormControl from "../_Components/GlobalFormControl";

const AgentCommision = (props) => {
  const [commisionGroups, setCommisionGroups] = useState();
  const [
    allCommisionGroupsWithoutPagination,
    setAllCommisionGroupsWithoutPagination,
  ] = useState();
  const [showCreateCommissionGroupModal, setShowCreateCommissionGroupModal] =
    useState(false);
  const [selectedCommissionId, setSelectedCommissionId] = useState(null);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    reset,
    watch,
  } = useForm({});
  const methods = {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
  };
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  useEffect(() => {
    (async () => {
      try {
        const data = await ApiAgentCommission.getAllAgentCommissions({
          pageSize: getValues("pageSize"),
          pageNumber: getValues("pageNumber"),
          globalSearch: searchParams.get("globalSearch") || "",
        });
        setCommisionGroups(data);
        setValue("totalCount", data.totalCount);
        const data2 =
          await ApiAgentCommission.getAllAgentCommissionsWithoutPagination();
        setAllCommisionGroupsWithoutPagination(data2.data);
        const formInputs = [
          { name: "globalSearch", type: "text", defaultValue: "" },
          { name: "pageSize", type: "number", defaultValue: "" },
          { name: "pageNumber", type: "number", defaultValue: "" },
        ];
        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);
      } catch (error) {
      }
    })();
  }, []);

  const onSubmit = async (data) => {
    tools.setPageNumber(data, searchParams, setValue);
    const apiData = await ApiAgentCommission.getAllAgentCommissions(data);
    setCommisionGroups(apiData);
    setValue("totalCount", apiData.totalCount);
    const queryString = tools.createQueryStringFromFromData(
      _.omit(data, ["totalPages", "totalCount"])
    );
    navigate(`/agentCommissions?${queryString}`);
  };

  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pb-3 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">
              گروه های کمیسیون
            </span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">
              لیست گروه های کمیسیون شما
            </span>
          </h3>
          <div className="card-toolbar">
            <Button
              className="btn btn-primary"
              onClick={() => {
                setSelectedCommissionId(0);
                setShowCreateCommissionGroupModal(true);
              }}
            >
              <AddCircle className="mr-1" />
              ایجاد گروه کمیسیون جدید
            </Button>
          </div>
        </div>
        {/*Start body */}
        <div className="card-body pt-3 pb-0">
          <FormProvider {...methods}>
            <form id="form" onSubmit={methods.handleSubmit(onSubmit)}>
              {/* search box */}
              <div className="border-top pt-3">
                <InputGroup className="mb-3">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <GlobalFormControl
                        type="text"
                        aria-describedby="basic-addon1"
                        placeholder="جستجو ..."
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />

                  <Button
                    variant="secondary"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <Spinner animation="border" variant="warning" size="sm" />
                    ) : (
                      <SearchIcon />
                    )}
                  </Button>
                </InputGroup>
              </div>
              {/* table */}
              <Col xs="12" className="tb-reponsive px-0">
                <DataGrid
                  data={commisionGroups}
                  setSelectedCommissionId={setSelectedCommissionId}
                  setShowCreateCommissionGroupModal={
                    setShowCreateCommissionGroupModal
                  }
                />
              </Col>
            </form>
          </FormProvider>
          {showCreateCommissionGroupModal && (
            <CreateCommissionGroupModal
              showCreateCommissionGroupModal={showCreateCommissionGroupModal}
              setShowCreateCommissionGroupModal={
                setShowCreateCommissionGroupModal
              }
              selectedCommissionId={selectedCommissionId}
              allCommisionGroupsWithoutPagination={
                allCommisionGroupsWithoutPagination
              }
            />
          )}
        </div>
      </div>
    </div >
  );
};

export default AgentCommision;
